import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type EventTypeWeWillFindForYou = "find_for_open" | "find_for_interaction" | "find_for_sent" | "find_for_close" | "find_for_back";

interface IGtmWeWillFindForYouBase {
    event: EventTypeWeWillFindForYou;
}

/**
 * When clicking the button that opens the modal
 */
export const gtmWeWillFindForYouOpen = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_open"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * When interacting with the form, i.e. choosing the location, number of rooms, area
 */
export const gtmWeWillFindForYouInteraction = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_interaction"
    };

    hitGoogleTagManager(gtmData);
};

export interface IGtmWeWillFindForYouSent extends IGtmWeWillFindForYouBase {
    find_for_rooms?: string;
    find_for_place?: string;
    find_for_size?: string;
}
/**
 * When submitting a contact form
 */
export const gtmWeWillFindForYouSent = (gtmData: IGtmWeWillFindForYouSent) => {
    hitGoogleTagManager(gtmData);
};

/**
 * When closing the "X" form or if it is possible after clicking outside the modal
 */
export const gtmWeWillFindForYouClose = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_close"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * When clicking "back to page" after submitting the form
 */
export const gtmWeWillFindForYouBack = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_back"
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export type EventTypeWeWillFindForYou = "find_for_open" | "find_for_interaction" | "find_for_sent" | "find_for_close" | "find_for_back";

interface IGtmWeWillFindForYouBase {
    event: EventTypeWeWillFindForYou;
}

/**
 * When clicking the button that opens the modal
 */
export const gtmWeWillFindForYouOpen = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_open"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * When interacting with the form, i.e. choosing the location, number of rooms, area
 */
export const gtmWeWillFindForYouInteraction = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_interaction"
    };

    hitGoogleTagManager(gtmData);
};

export interface IGtmWeWillFindForYouSent extends IGtmWeWillFindForYouBase {
    find_for_rooms?: string;
    find_for_place?: string;
    find_for_size?: string;
}
/**
 * When submitting a contact form
 */
export const gtmWeWillFindForYouSent = (gtmData: IGtmWeWillFindForYouSent) => {
    hitGoogleTagManager(gtmData);
};

/**
 * When closing the "X" form or if it is possible after clicking outside the modal
 */
export const gtmWeWillFindForYouClose = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_close"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * When clicking "back to page" after submitting the form
 */
export const gtmWeWillFindForYouBack = () => {
    const gtmData: IGtmWeWillFindForYouBase = {
        event: "find_for_back"
    };

    hitGoogleTagManager(gtmData);
};
